import {DeclarationStatus} from './declarations';

export const CUSTOMS_AUDIT_EVENTS = [
    'AUTH_LOGIN_SUCCESS',
    'AUTH_LOGIN_FAILED',
    'AUTH_LOGOUT',
    'AUTH_PASSWORD_CHANGED',
    'USER_CREATED',
    'USER_UPDATED',
    'USER_BRANCHES_UPDATED',
    'BRANCH_CREATED',
    'BRANCH_UPDATED',
    'NOTIFICATION_VIEWED',
    'NOTIFICATION_NUMBER_SET',
    'NOTIFICATION_STATUS_CHANGED',
] as const;
export type CustomsAuditEventType = typeof CUSTOMS_AUDIT_EVENTS[number];

export const FAILURE_REASONS = ['INVALID_PASSWORD', 'USER_NOT_FOUND', 'USER_INACTIVE'] as const;
export type FailureReason = typeof FAILURE_REASONS[number];

export interface CustomsAuditLogParams {
    paging: {
        pageSize: number;
        pageRef?: string | null;
    };
    eventId?: string;
    eventTypes?: CustomsAuditEventType[];
    userId?: number;
    userFullName?: string;
    userRole?: string;
    branchId?: number;
    branchName?: string;
    notificationId?: string;
    declarationNumber?: string;
    from?: string;
    to?: string;
    sortDesc?: boolean;
}

export type branch = {
    id: number;
    number: string;
    name: string;
    address: string;
};

export interface CustomsAuditData {
    eventId: string;
    eventType: CustomsAuditEventType;
    eventTime: string;
    userId: number;
    userFullName: string;
    userRole: string;
    organizationId: number;
    branchesAtEventTime: string;
    ipAddress: string;
    userAgent: string;
    notificationId: string;
    declarationNumber: string;
    notificationParticipantOrganizationId: number;
    details: {
        login: string;
        failureReason: FailureReason;
        targetUserId: number;
        targetUserFullName: string;
        branchesBefore: branch[];
        branchesAfter: branch[];
        branchId: number;
        branchNumber: string;
        branchName: string;
        branchAddress: string;
        changedFields: [
            {
                field: string;
                oldValue: string;
                newValue: string;
            },
        ];
        oldStatus: DeclarationStatus;
        newStatus: DeclarationStatus;
    };
    note: string;
}

export interface CustomsAuditLogPage {
    nextPageRef?: string | null;
    data: CustomsAuditData[];
}

export interface CustomsAuditItem {
    eventId: string;
    eventType: CustomsAuditEventType;
    eventTime: string;
    userId: number;
    userFullName: string;
    userRole: string;
    organizationId: number;
    branchesAtEventTime: string;
    ipAddress: string;
    userAgent: string;
    notificationId: string;
    declarationNumber: string;
    notificationParticipantOrganizationId: number;
    details: {
        login: string;
        failureReason: FailureReason;
        targetUserId: number;
        targetUserFullName: string;
        branchesBefore: branch[];
        branchesAfter: branch[];
        branchId: number;
        branchNumber: string;
        branchName: string;
        branchAddress: string;
        changedFields: [
            {
                field: string;
                oldValue: string;
                newValue: string;
            },
        ];
        oldStatus: string;
        newStatus: string;
    };
    note: string;
}
